import logWarningInDev from '@jetshop/core/helpers/logWarningInDev';
export function unSlugify(slug) {
    logWarningInDev(true, 'Update your queries to request "breadcrumbs" on routes, for improved performance');
    if (slug) {
        slug = slug
            .split('-')
            .map((part) => part.length > 0 ? part[0].toUpperCase() + part.substring(1) : '')
            .join(' ');
        slug = slug
            .split('/')
            .map((part) => part.length > 0 ? part[0].toUpperCase() + part.substring(1) : '')
            .join('/');
    }
    return slug;
}
//# sourceMappingURL=unslugify.js.map